const PastVitalsBt: React.FC<{
    isSelected: boolean;
}> = ({ isSelected }) => {
    const isFilled = false;
    return (
        <div className={`menuitem ${isFilled ? 'filled' : ''} ${isSelected ? 'selected' : ''}`}>
            <div>
                <div>
                    <svg width="16" height="16" viewBox="0 0 640 512">
                        <path d="M636.11 390.15C614.44 308.85 580.07 231 534.1 159.13 511.98 124.56 498.03 96 454.05 96 415.36 96 384 125.42 384 161.71v60.11l-32.88-21.92a15.996 15.996 0 0 1-7.12-13.31V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v170.59c0 5.35-2.67 10.34-7.12 13.31L256 221.82v-60.11C256 125.42 224.64 96 185.95 96c-43.98 0-57.93 28.56-80.05 63.13C59.93 231 25.56 308.85 3.89 390.15 1.3 399.84 0 409.79 0 419.78c0 61.23 62.48 105.44 125.24 88.62l59.5-15.95c42.18-11.3 71.26-47.47 71.26-88.62v-87.49l-85.84 57.23a7.992 7.992 0 0 1-11.09-2.22l-8.88-13.31a7.992 7.992 0 0 1 2.22-11.09L320 235.23l167.59 111.72a7.994 7.994 0 0 1 2.22 11.09l-8.88 13.31a7.994 7.994 0 0 1-11.09 2.22L384 316.34v87.49c0 41.15 29.08 77.31 71.26 88.62l59.5 15.95C577.52 525.22 640 481.01 640 419.78c0-9.99-1.3-19.94-3.89-29.63z" />
                    </svg>
                </div>
                <p>Vitals & Lab Trends</p>
            </div>
            <div>
                <svg
                    width="25"
                    height="25"
                    viewBox="0 0 28 28"
                    className="fill-neutral-5 cursor-pointer"
                    preserveAspectRatio="xMidYMid meet"
                >
                    {isFilled ? (
                        <path d="M10.0547 16.8125C10.2891 17.0469 10.6875 17.0469 10.9219 16.8125L17.8125 9.92188C18.0469 9.6875 18.0469 9.28906 17.8125 9.05469L16.9688 8.21094C16.7344 7.97656 16.3594 7.97656 16.125 8.21094L10.5 13.8359L7.85156 11.2109C7.61719 10.9766 7.24219 10.9766 7.00781 11.2109L6.16406 12.0547C5.92969 12.2891 5.92969 12.6875 6.16406 12.9219L10.0547 16.8125Z"></path>
                    ) : (
                        <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"></path>
                    )}
                </svg>
            </div>
        </div>
    );
};

export default PastVitalsBt;
